import { JsonObject } from "json2typescript";
import { NotificationResponseInterface } from "../interfaces/notification-response.interface";

@JsonObject('NotificationResponseModel')
export class NotificationResponseModel implements NotificationResponseInterface {
    Code: number;
    Date?: string;
    Description?: string;
    NotificationId?: string;
    Read?: boolean;
    Type?: string;
}